<template>
  <el-dialog
    title="补发货出库单"
    :visible.sync="visible"
    width="720px"
    append-to-body=""
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      label-width="100px"
      :model="orderInfo">
      <!-- <el-form-item label="外部订单号:"> {{ orderInfo.outerOrderCode }} </el-form-item> -->
      <el-form-item label="订单号:"> {{ orderInfo.code }} </el-form-item>
      <el-form-item label="订单标记:">{{ orderInfo.orderFlag | orderTagName() }}</el-form-item>
      <el-form-item label="发货仓库:">
        <el-input
          v-model="orderInfo.warehouseNo"
          readonly="">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="selectWarehouse"></el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="快递模板:">
        <ent-logistics-select
          v-model="orderInfo.logisticsCode"
          :option="{vendorId: userInfo.orgId}" />
      </el-form-item>
      <el-form-item label="收件人:">
        <div>
          <span>{{ orderInfo.receiverName }}</span>
          <span v-if="orderInfo.receiverMobile">
            <i
              style="margin-left: 5px"
              class="el-icon-mobile-phone"></i>{{ orderInfo.receiverMobile }}
          </span>
          <span v-if="orderInfo.receiverTel">
            <i
              style="margin-left: 5px"
              class="el-icon-phone-outline"></i>{{ orderInfo.receiverTel }}
          </span>
        </div>
        <div>{{ orderInfo.receiverProvince }}{{ orderInfo.receiverCity }}{{ orderInfo.receiverDistrict }}-{{ orderInfo.receiverAddress }}</div>
      </el-form-item>
      <el-form-item label="备注:"> {{ orderInfo.remark }}</el-form-item>
      <el-form-item
        label="订单明细:"
        prop="detailList">
        <el-table
          v-loading="loading"
          max-height="400px"
          :data="orderInfo.detailList"
          border>
          <el-table-column
            :resizable="false"
            label="商品名称"
            prop="skuName"></el-table-column>
          <el-table-column
            :resizable="false"
            label="商品编码"
            width="80"
            prop="skuCode"></el-table-column>
          <!-- <el-table-column
            label="下单数量"
            width="70"
            :resizable="false"
            prop="num">
          </el-table-column>
          <el-table-column
            :resizable="false"
            width="100"
            label="出库单">
            <el-table-column
              :resizable="false"
              width="70"
              label="已生成"
              prop="outNum"></el-table-column>
            <el-table-column
              :resizable="false"
              width="70"
              label="待生成"
              prop="needOut"></el-table-column>
          </el-table-column> -->
          <el-table-column
            label="出库数量"
            :resizable="false"
            prop="num">
            <template slot-scope="{row,$index}">
              <el-form-item
                style="margin-bottom:0"
                label-width="0"
                :prop="'detailList.' + $index + '.tempnum'">
                <el-popover
                  placement="top"
                  title="库存"
                  trigger="hover">
                  <div style="font-size: 12px;">
                    <div>仓库：{{ row.warehouse.warehouseNo }}</div>
                    <div>库存：{{ row.warehouse.num }}</div>
                  </div>
                  <el-input-number
                    slot="reference"
                    v-model="orderInfo.detailList[$index].tempnum"
                    style="width: 100%"
                    :precision="0"
                    :max="row.maxNum"
                    :min="0"></el-input-number>
                </el-popover>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        @click="add">确 定</el-button>
    </div>
    <warehouse-select-modal
      ref="warehouse"
      :callback="warehouseCallback" />
    <!-- <product-select-modal
      ref="modal"
      :option="{vendorId: userInfo.orgId}"
      @update:list="updateProductItems" /> -->
  </el-dialog>
</template>
<script>
import WarehouseSelectModal from './warehouse-select-modal.vue'
import EntLogisticsSelect from '../../../components/business/ent-logistics-select.vue'
// import ProductSelectModal from './product-select-new-modal.vue'
import { mapState } from 'vuex'
import _ from 'lodash'
export default {
  name: 'OrderExtraModal',
  components: { WarehouseSelectModal, EntLogisticsSelect },
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      salesOrderId: null,
      orderInfo: {},
      visible: false
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {},
    add() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const detailList = this.orderInfo.detailList.filter(s => s.tempnum > 0)
          if (detailList.length === 0) {
            this.$message.error('出库数量不能为空')
            return
          }
          this.loading = true
          this.$store.dispatch('outstock/outadd', {
            payload: {
              'bizOrderId': this.orderInfo.id,
              'bizOrderCode': this.orderInfo.code,
              'warehouseNo': this.orderInfo.warehouseNo,
              ownerCode: this.orderInfo.ownerCode,
              expressCode: this.orderInfo.logisticsCode,
              outType: this.orderInfo.outType,
              transType: 1,
              'type': 99, // 'int //单据类型 XSCK(21, "销售出库"), PDCK(22, "盘点出库"), DBCK(23, "调拨出库"), SCCK(24, "调拨出库"), QTCK(99, "其他出库");
              'detailList': detailList.map(s => {
                return {
                  'outOrderId': this.orderInfo.id,
                  // 'bizOrderDetailId': 'long //业务单明细id',
                  // 'stockId': 'long //库存id,仓库库存Id【必须】',
                  'bizOrderDetailId': s.id,
                  'skuId': s.skuId,
                  'num': s.tempnum,
                  stockId: s.warehouse.id
                }
              })
              // [{
              //   'outOrderId': 'long //出库单id',
              //   'bizOrderDetailId': 'long //业务单明细id',
              //   'stockId': 'long //库存id,仓库库存Id【必须】',
              //   'skuId': 'long //商品id【必须】',
              //   'num': 'int //出库数量'
              // }]
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    selectWarehouse() {
      this.$refs.warehouse.fetch({
        departmentId: this.orderInfo.ownerCode,
        productIds: this.orderInfo.detailList.map(i => i.skuId)
        // productLineNos: [this.orderInfo.ownerCode]
      })
    },
    warehouseCallback(row) {
      this.orderInfo.warehouseNo = row.warehouseNo
      this.getstocklist(this.orderInfo.warehouseNo, this.orderInfo.detailList.map(i => i.skuId))
    },
    addProduct() {
      this.$refs.modal.fetch(this.orderInfo.detailList)
    },
    updateProductItems(rows) {
      console.log(rows)
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('outstock/salesdetail', {
        payload: {
          salesOrderId: this.salesOrderId
        },
        success: res => {
          this.loading = false
          res.data.data.detailList.forEach(i => {
            i.tempnum = 0
            i.warehouse = { skuId: i.skuId, id: null, num: 0 }
          })
          this.orderInfo = {
            ...res.data.data,
            logisticsCode: res.data.data.logisticsCode ? +res.data.data.logisticsCode : null,
            orderFlag: +res.data.data.orderFlag
          }
          this.getstocklist(this.orderInfo.warehouseNo, this.orderInfo.detailList.map(i => i.skuId))
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    getstocklist(warehouseNo, skuIdList) {
      this.$store.dispatch('outstock/stocklist', {
        payload: {
          pageNum: 1,
          pageSize: 1000,
          warehouseNo,
          skuIdList
        },
        success: (res) => {
          console.log(res)
          const records = res.data.data.records
          this.loading = false
          const detailList = _.cloneDeep(this.orderInfo.detailList)
          detailList.forEach(i => {
            const item = records.find(s => s.skuId === i.skuId) || { skuId: i.skuId, warehouseNo, id: null, num: 0 }
            i.warehouse = item
            i.maxNum = i.needOut > item.num ? item.num : i.needOut
          })
          this.$set(this.orderInfo, 'detailList', detailList)
        },
        fail: () => {
          this.loading = false
          const records = []
          const detailList = _.cloneDeep(this.orderInfo.detailList)
          detailList.forEach(i => {
            const item = records.find(s => s.skuId === i.skuId) || { skuId: i.skuId, warehouseNo, id: null, num: 0 }
            i.warehouse = item
            i.maxNum = i.needOut > item.num ? item.num : i.needOut
          })
          this.$set(this.orderInfo, 'detailList', detailList)
        }
      })
    },
    fetch(salesOrderId) {
      this.salesOrderId = salesOrderId
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
